/**
 * Page Links Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initPageLinks() {
        const blocks = document.querySelectorAll('.page-links');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] page-links block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPageLinks);
    } else {
        initPageLinks();
    }
})();